{
  "title": "Delvis overdragelse av andelseierskap",
  "description": "Andelseier skal overdra andelseierskapet på én eller flere eiendommer til ny eier, men skal beholde andelseierskapet på resterende eiendommer.",
  "steps": {
    "receivers": "Overtaker(e)",
    "property": "Eiendommer",
    "capital": "Andelskapital",
    "summary": "Oppsummering"
  },
  "propertyStep": {
    "title": "Hvilke eiendommer skal overtaker overdra?",
    "description": "Velg hvilke eiendommer som skal overdras"
  },
  "transferFormRequired": "Du må laste opp overdragelsesskjema for hver overtaker for å fortsette"
}
